<footer>
<!--  <img-->
<!--    #iaTrigger-->
<!--    ngSrc="/assets/images/icons/icon-ia.svg"-->
<!--    alt="IA Logo"-->
<!--    class="footer-icon"-->
<!--    height="61" width="68"-->
<!--    (click)="openLanguagePopup(iaTrigger)"-->
<!--  />-->

  <!-- Bug Report Button -->
  <button
    class="bug-report-button"
    (click)="openBugReportModal()"
    title="{{ 'bug-report.button-title' | translate }}"
  >
    <img ngSrc="/assets/images/icons/help-circle.svg" alt="Help icon" height="24" width="24">
  </button>

  <!-- AI Chatbot -->
  <app-chatbot></app-chatbot>

  <div class="floating-footer" *ngIf="showFloatingFooter">
    <nav class="footer-nav">
      <!-- Institution users (Principal, Teacher, School): only show Inicio with different route -->
      <ng-container *ngIf="isInstitutionUser; else studentNav">
        <a routerLink="/dashboard/institution/classes/list" [ngClass]="{'font-primary--b': isActive('/dashboard/institution/classes/list')}">
          {{ "shared-components.footer.home" | translate }}
        </a>
      </ng-container>

      <!-- Student users: show full navigation -->
      <ng-template #studentNav>
        <a routerLink="/dashboard/home" [ngClass]="{'font-primary--b': isActive('/dashboard/home')}">
          {{ "shared-components.footer.home" | translate }}
        </a>
      </ng-template>
    </nav>
  </div>

</footer>

<!--<ng-template #languagePopupTemplate>-->
<!--  <div class="language-popup">-->
<!--    <div class="language-popup__header">-->
<!--      {{ "shared-components.footer.title_language" | translate }}-->
<!--      <img ngSrc="/assets/images/icons/icon-select-language.svg" alt="Icon" height="22" width="22">-->
<!--    </div>-->

<!--    <ul class="language-popup__list">-->
<!--      <li *ngFor="let language of languages" (click)="switchLang(language.code)"-->
<!--          [ngClass]="{'active-language': language.code === currentLang}">-->
<!--        {{ language.label }}-->
<!--      </li>-->
<!--    </ul>-->
<!--  </div>-->
<!--</ng-template>-->
